import React, { useContext, useState, useEffect } from 'react';
import AppContext from '../../AppContext';
import { 
    Grid, 
    Typography, 
    Box, 
    Tabs,
    Tab,
    Card,
    CardContent,
    Button,
    Snackbar,
    Alert,
    Zoom,
    Paper
} from '@mui/material';
import { ShoppingCart, LocalDining, Category } from '@mui/icons-material';
import '../../styles/appStyles.css';
import {Link, Navigate} from 'react-router-dom';

const Menu = () => {
    const { cart, setCart } = useContext(AppContext);
    const {products, setProducts} = useContext(AppContext);
    const [selectedCategory, setSelectedCategory] = useState(products?.[0]?.categoryName || '');
    const [snackbarOpen, setSnackbarOpen] = useState(false);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    if (
        !products ||
        products.length === 0 ||
        products.every(category => !category.items || category.items.length === 0)
    ) {
        return <Navigate to="/" />;
    }

    const handleCategoryChange = (event, newValue) => {
        setSelectedCategory(newValue);
    };

    const filteredProducts = products
        .filter(category => category.categoryName === selectedCategory)
        .flatMap(category => category.items);

    const addToCart = (product) => {
        const existingProductIndex = cart.findIndex((item) => item.name === product.name);

        if (existingProductIndex !== -1) {
            const updatedCart = [...cart];
            updatedCart[existingProductIndex].quantity += 1;
            setCart(updatedCart);
        } else {
            setCart([...cart, { ...product, quantity: 1 }]);
        }

        setSnackbarOpen(true);
    };

    return (
        <Box sx={{ maxWidth: '1200px', mx: 'auto', px: 2 }}>
            <Typography
                variant="h4"
                gutterBottom
                align="center"
                sx={{
                    fontWeight: 'bold',
                    fontSize: { xs: '2rem', md: '2.5rem' },
                    mb: 3,
                    backgroundImage: 'linear-gradient(45deg, var(--primary-color), var(--secondary-color))',
                    backgroundClip: 'text',
                    textFillColor: 'transparent',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                }}
            >
                <LocalDining sx={{ fontSize: { xs: '1.8rem', md: '2.3rem' }, mr: 1, verticalAlign: 'text-bottom' }} />
                Menu
            </Typography>
                            <Paper className="category-tabs" elevation={2} sx={{ p: 1, position: 'relative', overflow: 'visible' }}>
                <Box className="category-tabs-left-indicator" sx={{ position: 'absolute', left: -10, top: 0, width: '40px', height: '100%', zIndex: 5 }}></Box>
                <Tabs
                    value={selectedCategory}
                    onChange={handleCategoryChange}
                    variant="scrollable"
                    scrollButtons="auto"
                    TabIndicatorProps={{ style: { display: 'none' } }}
                    sx={{
                        '& .MuiTab-root': { color: 'var(--dark-color)' },
                        '& .MuiTabs-flexContainer': { gap: '8px', height: '100%' },
                        overflowX: 'auto',
                        '&::-webkit-scrollbar': { display: 'none' },
                        '& .Mui-selected': { color: 'white !important' },
                        '& .Mui-selected .MuiTab-wrapper': { color: 'white !important' },
                        '& .Mui-selected span': { color: 'white !important' },
                        height: '100%'
                    }}
                >
                    {products.map((category) => (
                        <Tab
                            key={category.categoryName}
                            label={<span style={{ color: selectedCategory === category.categoryName ? 'white' : 'var(--dark-color)' }}>{category.categoryName}</span>}
                            value={category.categoryName}
                            className="category-tab"
                            disableRipple
                            sx={{
                                color: 'var(--dark-color)',
                                '&.Mui-selected': { 
                                    color: 'white !important',
                                    height: '100%',
                                    borderRadius: '50px',
                                    background: 'linear-gradient(135deg, var(--primary-color), var(--secondary-color))',
                                    '& .MuiTab-wrapper': { color: 'white !important' },
                                    '& span': { color: 'white !important' }
                                },
                                height: '100%',
                                borderRadius: '50px',
                                minHeight: '38px',
                                '& .MuiTab-wrapper': { color: 'inherit' },
                                '& span': { color: 'inherit' }
                            }}
                        />
                    ))}
                </Tabs>
            </Paper>
                            <Grid container spacing={3}>
                {filteredProducts.map((product, index) => (
                    <Grid item xs={12} sm={6} md={4} key={index}>
                        <Zoom in={true} style={{ transitionDelay: `${index * 100}ms` }}>
                            <Card className="product-card">
                                {product.image && (
                                    <Box className="product-image-container">
                                        <img
                                            src={product.image}
                                            alt={product.name}
                                            className="product-image"
                                        />
                                    </Box>
                                )}
                                                                    <CardContent className="product-content" sx={{ pt: 1 }}>
                                    <Typography className="product-title" sx={{ fontWeight: 700 }}>{product.name}</Typography>
                                    <Typography className="product-description">
                                        {product.description}
                                    </Typography>
                                    <Typography className="product-price">{product.price} zł</Typography>
                                    <Button
                                        variant="contained"
                                        size="medium"
                                        fullWidth
                                        onClick={() => addToCart(product)}
                                        className="add-button"
                                        startIcon={<ShoppingCart />}
                                    >
                                        Dodaj do koszyka
                                    </Button>
                                </CardContent>
                            </Card>
                        </Zoom>
                    </Grid>
                ))}
            </Grid>

            <Snackbar
                open={snackbarOpen}
                autoHideDuration={3000}
                onClose={() => setSnackbarOpen(false)}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            >
                <Alert
                    onClose={() => setSnackbarOpen(false)}
                    severity="success"
                    className="toast-notification"
                    sx={{ 
                        background: 'linear-gradient(135deg, var(--success-color), #7bed9f)',
                        color: 'white',
                        px: 2,
                        py: 1.5,
                        fontSize: '1rem'
                    }}
                    action={
                        <Button
                            color="inherit"
                            size="small"
                            component={Link}
                            to="/cart"
                            sx={{ 
                                fontWeight: 'bold', 
                                backgroundColor: 'rgba(255,255,255,0.2)', 
                                borderRadius: '50px',
                                '&:hover': { backgroundColor: 'rgba(255,255,255,0.3)' },
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                textAlign: 'center'
                            }}
                        >
                            Przejdź do koszyka
                        </Button>
                    }
                    icon={<ShoppingCart sx={{ mr: 1 }} />}
                >
                    Produkt został dodany do koszyka!
                </Alert>
            </Snackbar>
        </Box>
    );
};

export default Menu;